import { render, staticRenderFns } from "./ActUnlockLimitSupply.vue?vue&type=template&id=2ce40e16&scoped=true"
import script from "./ActUnlockLimitSupply.vue?vue&type=script&lang=js"
export * from "./ActUnlockLimitSupply.vue?vue&type=script&lang=js"
import style0 from "./ActUnlockLimitSupply.vue?vue&type=style&index=0&id=2ce40e16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce40e16",
  null
  
)

export default component.exports